(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["clothing-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.goldtexClothingMega) return;
    window.goldtexClothingMega = true;

    function resizeOpenMenu(root) {
      var item = root.closest('li');
      var wrapper = root.closest('.navmenu-meganav-wrapper');
      if (item && wrapper) {
        item.style.setProperty('--menu-open-height', wrapper.scrollHeight + 'px');
      }
      var accordion = root.closest('[data-accordion-content]');
      if (accordion) accordion.style.setProperty('--menu-open-height', accordion.scrollHeight + 'px');
    }

    function selectTab(root, name) {
      root.setAttribute('data-clothing-picked', 'true');
      var tabs = root.querySelectorAll('[data-clothing-tab]');
      var panels = root.querySelectorAll('[data-clothing-panel]');
      for (var i = 0; i < tabs.length; i++) {
        var selected = tabs[i].getAttribute('data-clothing-tab') === name;
        tabs[i].setAttribute('aria-selected', selected ? 'true' : 'false');
        if (selected) tabs[i].removeAttribute('tabindex');
        else tabs[i].setAttribute('tabindex', '-1');
      }
      for (var j = 0; j < panels.length; j++) {
        if (panels[j].getAttribute('data-clothing-panel') === name) panels[j].removeAttribute('hidden');
        else panels[j].setAttribute('hidden', '');
      }
      resizeOpenMenu(root);
      window.requestAnimationFrame(function () {
        resizeOpenMenu(root);
      });
    }

    function watchMobileMenu(root) {
      if (root.closest('.navmenu-meganav--desktop')) return;
      var accordion = root.closest('[data-accordion-content]');
      if (!accordion || accordion.getAttribute('data-clothing-collapse-bound') === 'true') return;
      accordion.setAttribute('data-clothing-collapse-bound', 'true');
      var observer = new MutationObserver(function () {
        var accordionState = accordion.getAttribute('data-accordion-state');
        var animationState = accordion.getAttribute('data-animation-state');
        if (accordionState === 'closed' || animationState === 'closed') {
          root.removeAttribute('data-clothing-picked');
          var openTabs = root.querySelectorAll('[data-clothing-tab]');
          var openPanels = root.querySelectorAll('[data-clothing-panel]');
          for (var tabIndex = 0; tabIndex < openTabs.length; tabIndex++) {
            openTabs[tabIndex].setAttribute('aria-selected', 'false');
            openTabs[tabIndex].setAttribute('tabindex', '-1');
          }
          for (var panelIndex = 0; panelIndex < openPanels.length; panelIndex++) {
            openPanels[panelIndex].setAttribute('hidden', '');
          }
        }
      });
      observer.observe(accordion, {
        attributes: true,
        attributeFilter: ['data-accordion-state', 'data-animation-state']
      });
    }

    var menus = document.querySelectorAll('[data-clothing-mega]');
    for (var menuIndex = 0; menuIndex < menus.length; menuIndex++) {
      watchMobileMenu(menus[menuIndex]);
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-clothing-tab]');
      if (!button) return;
      var root = button.closest('[data-clothing-mega]');
      if (!root) return;
      selectTab(root, button.getAttribute('data-clothing-tab'));
    }, true);

    document.addEventListener('pointerover', function (event) {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var button = event.target.closest('[data-clothing-tab]');
      if (!button || button.getAttribute('aria-selected') === 'true') return;
      var root = button.closest('[data-clothing-mega]');
      if (!root) return;
      selectTab(root, button.getAttribute('data-clothing-tab'));
    }, true);

    document.addEventListener('keydown', function (event) {
      var button = event.target.closest('[data-clothing-tab]');
      if (!button) return;
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      var root = button.closest('[data-clothing-mega]');
      if (!root) return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-clothing-tab]'));
      var index = tabs.indexOf(button);
      if (index < 0) return;
      var next = event.key === 'ArrowRight' ? index + 1 : index - 1;
      if (next < 0) next = tabs.length - 1;
      if (next >= tabs.length) next = 0;
      event.preventDefault();
      tabs[next].focus();
      selectTab(root, tabs[next].getAttribute('data-clothing-tab'));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["country-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-country-selector]');
    if (!root || root.getAttribute('data-country-selector-ready') === 'true') return;
    root.setAttribute('data-country-selector-ready', 'true');

    var form = root.querySelector('form');
    var back = root.querySelector('[data-country-back]');
    var params = new URLSearchParams(window.location.search);
    var returnTo = params.get('return_to') || '';
    var safe = returnTo.charAt(0) === '/'
      && returnTo.charAt(1) !== '/'
      && returnTo.indexOf('\\') === -1
      && returnTo.indexOf(':') === -1
      && returnTo.indexOf('@') === -1;

    if (safe && form) {
      var input = form.querySelector('input[name="return_to"]');
      if (input) input.value = returnTo;
    }

    if (safe && back) back.setAttribute('href', returnTo);

    var search = root.querySelector('[data-country-search]');
    var options = root.querySelectorAll('[data-country-option]');
    var empty = root.querySelector('[data-country-empty]');
    if (!search) return;

    search.addEventListener('input', function () {
      var query = search.value.trim().toLowerCase();
      var visible = 0;

      options.forEach(function (option) {
        var haystack = (option.getAttribute('data-country-option') || '').toLowerCase();
        var match = query === '' || haystack.indexOf(query) !== -1;
        option.hidden = !match;
        if (match) visible += 1;
      });

      if (empty) empty.hidden = visible !== 0;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tiny-love-brand"] && !Shopify.designMode) return;
  try {
    function initTinyLoveShop() {
    document.querySelectorAll('[data-tl-shop]').forEach(function (root) {
      if (root.dataset.tlReady === 'true') return;
      root.dataset.tlReady = 'true';
      var track = root.querySelector('[data-tl-track]');
      var prev = root.querySelector('[data-tl-prev]');
      var next = root.querySelector('[data-tl-next]');
      if (!track || !prev || !next) return;

      function update() {
        var max = track.scrollWidth - track.clientWidth - 4;
        prev.hidden = track.scrollLeft <= 4;
        next.hidden = track.scrollLeft >= max;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTinyLoveShop);
  } else {
    initTinyLoveShop();
  }
  } catch(e) { console.error(e); }
})();

})();
